import { actions } from 'react-redux-form'
import { httpError } from 'actions/http'
import JobAd from 'careers/services/job-ad'

export const ADS_REQUEST = 'ADS_REQUEST'
export const ADS_RECEIVE = 'ADS_RECEIVE'
export const SET_UNPUBLISHED = 'SET_UNPUBLISHED'

export const setUnpublished = value => ({ type: SET_UNPUBLISHED, value })

export const requestAds = companySlug => ({ type: ADS_REQUEST, companySlug })

export const receiveAds = company => ({ type: ADS_RECEIVE, company })

export const fetchAds = params => (dispatch) => {
  dispatch(requestAds(params.companySlug))
  return JobAd.list(params.companySlug)
    .then((company) => {
      dispatch(receiveAds(company))
    })
    .catch((err) => {
      if (err.response && err.response.status && err.response.status === 404) {
        dispatch(httpError(err.response.status))
      } else {
        throw err
      }
    })
}

export const fetchAdsIfNeeded = params => (dispatch, getState) => {
  if (shouldFetchAds(getState(), params.companySlug)) {
    return dispatch(fetchAds(params))
  }
  return Promise.resolve()
}

export const fetchAd = params => (dispatch, getState) => dispatch(fetchAdsIfNeeded(params)).then(() => {
  let request
  const { token } = getState().routing.locationBeforeTransitions.query
  if (token) {
    request = JobAd.getWithToken(token)
  } else {
    request = JobAd.get(params.companySlug, params.adSlug)
  }
  request
    .then((jobAd) => {
      const previousJobAd = getState().jobAd
      if (previousJobAd._id && previousJobAd._id !== jobAd._id) {
        dispatch(actions.reset('application'))
      }
      const ad = token ? { ...jobAd, hideShare: true } : jobAd
      dispatch(actions.change('jobAd', ad))
    })
    .catch((err) => {
      if (err.response && err.response.status && [404, 410, 403].includes(err.response.status)) {
        if (err.response.status === 403 && err.response.response && err.response.response.includes('unpublished')) {
          dispatch(setUnpublished(true))
        } else {
          dispatch(httpError(err.response.status))
        }
      } else {
        throw err
      }
    })
})

function shouldFetchAds(state, companySlug) {
  if (typeof state.careers.company !== 'undefined' && state.careers.company.slug === companySlug) {
    return false
  }
  if (state.careers.isFetching) {
    return false
  }
  return true
}
